module.exports = __webpack_public_path__ + "img/person-sledding.476f6910.svg";